import dayjs from 'dayjs';

import { mapProjectStatusFromDTO } from '@/modules/projects/mappers/project-status.mapper';

import { AssignmentProject } from '../types/assignment-project';
import { AssignmentProjectResponse } from '../types/dto/response/assignment-project-response';
import { PlannerAssignmentProjectResponse } from '../types/dto/response/planner-assignment-project-response';

/**
 * Maps the assignment's project to the planner domain model.
 * Components (e.g. the assignment tooltip) consume the domain model — the raw
 * Response DTO must not cross into the component layer.
 *
 * The project data arrives on two nodes: `response` is the shared assignment
 * project (name, colour), `plannerProject` is the planner-only enrichment
 * (client name, tentative probability, status info). `plannerProject` is absent
 * for assignments not sourced from a planner response (e.g. optimistic entries),
 * in which case the enriched fields read as unknown.
 */
export const mapAssignmentProjectFromResponse = (
  response: AssignmentProjectResponse | undefined,
  plannerProject?: PlannerAssignmentProjectResponse
): AssignmentProject | undefined => {
  if (!response) return undefined;

  return {
    id: response.id,
    name: response.name,
    colorHex: response.colorHex,
    clientName: plannerProject?.clientName ?? null,
    tentativeProbability: plannerProject?.tentativeProbability ?? null,
    status: plannerProject?.status ? mapProjectStatusFromDTO(plannerProject.status) : undefined,
    startsAt: plannerProject?.startsAt ? dayjs(plannerProject.startsAt) : undefined,
    nextArchiveDate: plannerProject?.nextArchiveDate
      ? dayjs(plannerProject.nextArchiveDate)
      : undefined,
    nextUnarchiveDate: plannerProject?.nextUnarchiveDate
      ? dayjs(plannerProject.nextUnarchiveDate)
      : undefined,
  };
};
